;(function(w){
	function LightboxContenidoHTMLContent(file){
		var self = this;
		this.main = document.createElement('div');
		this.main.className = 'scroll-holder';

		$.ajax({
			url: 'contenidos/'+file,
			type: 'get',
			success: onCargoContenido
		})

				
		$(window).bind('resize', onResize);

		function onCargoContenido(content){
			
			$(self.main).append(content);
			
			
			if(!Main.es_mobile){
				setTimeout(function(){
					$(self.main).mCustomScrollbar();
				},300)
			}

			$(self.main).find('.photo-gallery').each(function(){
				new LightboxContenidoGaleria(this);
			})

			$(self.main).find('.content-slider').each(function(){
				new LightboxContenidoSlider(this);
			})	
			
			$(self.main).find('.flipcard').each(function(){
				new LightboxContenidoFlipcard(this);
			})
			
			if(document.getElementById('timeline')){
				new LightboxContenidoTimeline();
			}
			

			onResize();
		}

		function onResize(e){
			$(self.main).css('height',$(window).height() - $(self.main).offset().top - 50);
		}
	}
	
	w.LightboxContenidoHTMLContent = LightboxContenidoHTMLContent;
})(window)